<template>
  <div :class="{'my-box': speaker==='my', 'other-box': speaker==='other'}">
    <carousel
      :navigationEnabled="true"
      :loop="true"
      :speed="250"
      navigation-prev-label="〈"
      navigation-next-label="〉"
      :paginationPadding = 2
      :per-page="1"
    >
      <slide v-for="(i, j ,k) in parameter" :key="k">
        <div class="slider-inner">
          <div v-if="i.image_ref.image_data==''">
            <img src="@/assets/template/no_image.svg">
          </div>
          <div v-else>
            <img onerror="this.src='@/assets/template/no_image.svg'" :src="i.image_ref.image_data">
          </div>
          <section class="contents-container">
            <div class="title">{{messageEscape(i.title)}}</div>
            <div class="contents">{{messageEscape(i.contents)}}</div>
            <button
              @click.once="pushButton(i, isBot, i.id-1)"
              :disabled="isNowButton()||!isButton"
              class="button is-small is-primary is-fullwidth"
              :class="{'btn-disabled':!isButton }">
              {{messageEscape(i.button)}}
            </button>
          </section>
        </div>
      </slide>
    </carousel>
  </div>
</template>

<script>
import { Carousel, Slide } from 'vue-carousel'
import {
  messageEscape,
  isNowButton
} from '@/functions/balloonFunc'

export default {
  name: 'CarouselParts',
  props: ['message', 'speaker', 'parameter', 'lastIndex', 'logIndex', 'isBot', 'isDemo', 'roboArguments'],
  methods: {
    messageEscape (m) {
      return messageEscape(m, this.roboArguments)
    },
    isNowButton () {
      return isNowButton(this.logIndex, this.lastIndex, this.speaker)
    },
    pushButton (i, isBot, btnIndex) {
      this.isButton = false
      var m = ''
      if (i.title === '') {
        m = '選択肢' + String(i.id)
      } else {
        m = i.title
      } 
      this.$emit('pushButton', m, isBot, btnIndex)
    }
  },
  components: {
    Carousel,
    Slide
  },
  data () {
    return {
      isButton: true
    }
  }
}
</script>

<style lang="scss" scoped>
.my-box {
  display: flex;
  justify-content: flex-end;
  flex-direction: column;
  margin-right: 10px;
  transition: 0.7s;
}
.other-box {
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  margin-left: 10px;
}
.slide-style {
  border: solid 1px #ccc;
  width: 320px;
}
.VueCarousel {
  height: auto;
  min-height: 330px;
  width: 90%;
  margin: 0 3%;
}
.VueCarousel-wrapper,
.VueCarousel-inner,
.VueCarousel-slide {
  height: auto; // 追加
  min-height: 300px; // 追加
  width: 90%;
}
.VueCarousel-slide .slider-inner {
  font-size: 17px; // 追加
  min-height: 18px; // 追加
  height: auto; //  height: calc(100% - 24px);から変更
  white-space: pre-wrap; // 追加
  word-wrap: break-word; // 追加
  margin: 10px;
  background-color: white;
  text-align: center;
  justify-content: center;
  align-items: center;
  color: black;
  border-radius: 20px;
  border: 1px solid #ccc;
  img {
    height: 130px;
    width: 100%;
    border-radius: 20px 20px 0 0;
    object-fit: scale-down;
  }
  .contents-container {
    padding: 12px;
    padding-bottom: 24px; // ボタンの下部余白を増加
    .title {
      font-size: 17px;
      min-height: 18px;
      height: auto;
      text-align: left;
      margin: 8px 0;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: pre-wrap;
      word-wrap: break-word;
    }
    .contents {
      font-size: 12px;
      min-height: 48px;
      height: auto; //      height: 48px;
      margin: 8px 0;
      margin-bottom: 8px;
      text-align: left;
      overflow: auto;
      text-overflow: ellipsis;
      white-space: pre-wrap;
      word-wrap: break-word;//追加
    }
    .contents::-webkit-scrollbar {
      width: 5px;
      height: 5px;
    }
  }
}
.VueCarousel-dot-container {
  margin-top: -20px;
}
.btn-disabled {
  background: rgb(240, 240, 240);
  color: gray;
  border: solid 2px gray;
}
.btn-disabled:hover {
  background: rgb(240, 240, 240);
    color: gray;
}
// > ボタン
/deep/ .VueCarousel-navigation-next {
  font-size: 2rem;
}
// < ボタン
/deep/ .VueCarousel-navigation-prev {
  font-size: 2rem;
}
</style>



// WEBPACK FOOTER //
// src/components/BalloonParts/CarouselParts.vue